import { HINAN_KUNREN_COMMON_ACCESS_KEY } from "../../config/HinanKunrenConfig";
import { SAITAMA_CITY_ACCESS_KEY, SAITAMA_CITY_PROVIDER } from "../../config/SaitamaCityConfig";

const LocalStorageHelper = {
  deleteAllLsData: function (prefix) {
    for (var i = localStorage.length - 1; i >= 0; i--) {
      if (localStorage.key(i).indexOf(prefix) !== -1) {
        localStorage.removeItem(localStorage.key(i));
      }
    }
  },

  deleteAllLocalStorageData: function () {
    for (var i = localStorage.length - 1; i >= 0; i--) {
      if (localStorage.key(i).indexOf("data_") !== -1) {
        localStorage.removeItem(localStorage.key(i));
      }
    }
  },

  getCompany: function () {
    let companyName = "tepco";
    if (localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9") {
      companyName = "ntt";
    } else if (localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3") {
      companyName = "hokuden";
    } else if (localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb") {
      companyName = "ntt-ft";
    } else if (localStorage.getItem("access_key") === "k3v9q1m7x8d2p5n0z6h4w1r9") {
      companyName = "mitsubishi";
    } else if (localStorage.getItem("access_key") === "k4x9d2p7m0v1q8t5wryb3zfn6") {
      companyName = "okiden";
    } else if (localStorage.getItem("access_key") === "dea") {
      companyName = "dea";
    } else if (localStorage.getItem("access_key") === HINAN_KUNREN_COMMON_ACCESS_KEY) {
      companyName = "common";
    } else if (localStorage.getItem("access_key") === SAITAMA_CITY_ACCESS_KEY) {
      companyName = SAITAMA_CITY_PROVIDER.company;
    }
    return companyName;
  },

  getLoggedinUserEmail: function () {
    try {
      const email = localStorage.getItem("email");
      return email ? email : "";
    } catch (e) {
      console.warn("Unable to access localStorage:", e);
      return "";
    }
  },
};

export default LocalStorageHelper;
